<div class="mGrid">
    <div class="mGrid__tiles tiles">
        <div class="tiles__item" v-for="placeholder in [1,2,3,4,5]" v-if="medias.length === 0">
            <div class="tiles__item-content" :style="{ backgroundImage: `url(${getStaticImages('placeholderprofile', 'jpg')})` }"></div>
        </div>
        <div class="tiles__item" v-for="(media, index) in medias.slice(0, showMoreMedia ? medias.length : 5)" :key="media.id">
            
            <div class="tiles__item-type" v-if="media.type" :class="media.type"></div>

            <div class="tiles__item-content" v-if="media.type === 'video'" :style="{ backgroundImage: `url(${getBackground(media)})` }">
                <video ref="vidPlayers" controlslist="nodownload noplaybackrate nofullscreen" disablepictureinpicture controls v-if="media.hasOwnProperty('name')">
                    <source :src="videoUrl(performer.id, media)" type="video/mp4" />
                </video>
                <div class="overlay" @click="tSlider(media.id)" v-if="!isPaidMedia(media)"></div>
            </div>

            <div class="tiles__item-content" v-if="media.type !== 'video'" :style="{ backgroundImage: `url(${getBackground(media)})` }">
                <img :src="getSliderImages(performer.id, media, 'large')" @click="tSlider(media.id)" />
            </div>

            <div class="tiles__item-buy" :class="{'video': media.type === 'video', 'photo': media.type === 'photo'}" v-if="isPaidMedia(media)"  @click="tSlider(media.id)">
                <img :src="getStaticImages('lock', 'png')" />
                <span>{{ media.price }} {{ $t('profile.credits') }}</span>
                <i>{{ media.validPeriod }} {{ $t('profile.days') }}</i>
            </div>

        </div>
    </div>
    <div class="mGrid__more" v-if="medias.length > 5">
        <button @click="showMoreMedia = !showMoreMedia" class="btn btn-xsmall btn-black">{{ !showMoreMedia ? $t('profile.showAll') : $t('profile.showLess') }}</button>
    </div>
</div>